export const colors = {
    primary: "#FF8A00",
    secondary: "#5C5C5C",
    tertiary: "white",
}